/*eslint-disable strict */

import React from "react";
import {Router, Route, IndexRoute, hashHistory} from "react-router";
import MainView from "./mainView";
import ScopeView from "./scopeView";
import StonesView from "./stones/stonesViews";
import SummaryView from "./projectSummary/summaryView";

let _scopeVisited = document.kvConfig.isBackend;
let _stonesVisited = document.kvConfig.isBackend;

export default class App extends React.Component {

  render() {
    return (
      <Router history={hashHistory}>
        <Route path="/" component={MainView}>
          <IndexRoute component={ScopeView} onEnter={this.scopeOnEnter}/>
          <Route path="/scope" component={ScopeView} onEnter={this.scopeOnEnter}/>
          <Route path="/stones" component={StonesView} onEnter={this.stonesOnEnter}/>
          <Route path="/summary" component={SummaryView} onEnter={this.summaryOnEnter}/>
        </Route>
      </Router>
    );
  }

  scopeOnEnter = () => {
    _scopeVisited = true;
  };

  stonesOnEnter = (nextState, replace) => {
    _stonesVisited = true;
    if (!_scopeVisited) {
      replace("/scope");
    }
  };

  summaryOnEnter = (nextState, replace) => {
    if (!_stonesVisited) {
      replace("/scope");
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/app.js